import { Alert } from 'components/ui';
import type { SignInAlertsProps } from './SignInAlerts.types';

const SignInAlerts = ({
  authErrorAlertContent,
  authRequirementsError,
  dismissAuthError,
  dismissRequirementsError,
  dismissSessionExpired,
  isRequirementsErrorDismissed,
  sessionExpiredMessage,
}: SignInAlertsProps) => (
  <>
    {authErrorAlertContent ? (
      <Alert onClose={dismissAuthError} severity="error" visualVariant="inlineError">
        {authErrorAlertContent}
      </Alert>
    ) : null}
    {authRequirementsError && !isRequirementsErrorDismissed ? (
      <Alert onClose={dismissRequirementsError} severity="error" visualVariant="inlineError">
        {authRequirementsError}
      </Alert>
    ) : null}
    {sessionExpiredMessage ? (
      <Alert
        id="auth-session-expired-alert"
        onClose={dismissSessionExpired}
        severity="info"
        visualVariant="inline">
        {sessionExpiredMessage}
      </Alert>
    ) : null}
  </>
);

export default SignInAlerts;
